import React, { useCallback, useState } from 'react';

import dayjs from '~/timeInit';

import { Box, Typography } from '@mui/material';

import { Region } from '@luxuryescapes/lib-regions';

import { types } from '../../../consts/types';
import { scheduleForType } from '../../../utils/scheduleForType';
import NewScheduleForm from '../../Common/Forms/NewScheduleForm';

type Props = {
  regions: Array<Region>;
  brandsValue: Array<string>;
  offerId: string;
  schedules: App.Offer['brand_schedules'];
  shouldMigrateSchedule: boolean;
};

export default function NewScheduleByType({ regions, brandsValue, offerId, schedules, shouldMigrateSchedule }: Props) {
  const [editing, setEditing] = useState(false);

  const onSuccess = useCallback(() => setEditing(false), []);
  const onSave = useCallback(() => setEditing(true), []);

  const scheduleIdListForTypes = (type: string) => schedules.filter((s) => s.type === type).map((s) => s.id);

  const availabilityStart = scheduleForType(schedules, 'availability', 'start');
  const availabilityEnd = scheduleForType(schedules, 'availability', 'end');

  return (
    <Box sx={{ mb: 4, py: 5, bgcolor: 'background.paper' }}>
      {types.map((type) => {
        const minDate = type.code === 'online_purchase' && availabilityStart ? dayjs(availabilityStart) : undefined;
        const maxDate = type.code === 'online_purchase' && availabilityEnd ? dayjs(availabilityEnd) : undefined;

        return (
          <Box key={type.code}>
            <Typography variant="h6" gutterBottom>
              {type.name}
            </Typography>
            <NewScheduleForm
              key={`NewScheduleForm-${type.code}`}
              idList={scheduleIdListForTypes(type.code)}
              offerId={offerId}
              brands={brandsValue}
              disabled={shouldMigrateSchedule || editing}
              onSave={onSave}
              onSuccess={onSuccess}
              type={type.code}
              regions={regions}
              end={scheduleForType(schedules, type.code, 'end')}
              start={scheduleForType(schedules, type.code, 'start')}
              minDate={minDate}
              maxDate={maxDate}
            />
          </Box>
        );
      })}
      {window.configs?.DEFAULT_TIMEZONE && (
        <Typography variant="body2" color="text.secondary" mt={2}>
          All times in {window.configs.DEFAULT_TIMEZONE}
        </Typography>
      )}
    </Box>
  );
}
